<script lang="ts">
    import type {Writable} from 'svelte/store';
    import {getContext} from 'svelte';

    /*
    headless-ui does not allow using custom ids for its listbox,
    and it manages aria-labelledby attributes, preventing us doing it manually.
    it also does not allow for custom label to be outside its container component
    to provide correct aria-labelledby information for select build with headless-uis listbox,
    we need to tap its internal API via svelte context.
    basically this component will inject fake label element with our id to headless-uis listbox context
    correct labelledby info on listbox
    * */

    export let labelId: string;

    if (!labelId) {
        throw new Error('labelId is required');
    }

    const LISTBOX_CONTEXT_NAME = 'headlessui-listbox-context';
    const api: Writable<any> = getContext(LISTBOX_CONTEXT_NAME);
    if (!api) {
        throw new Error(
            '<DropdownListboxLabelProvider /> is missing a parent <Listbox /> component.'
        );
    }
    const labelRef: Writable<Pick<HTMLLabelElement, 'id'> | null> = $api.labelRef;

    labelRef.set({id: labelId});

</script>
